import React from "react";
import styles from "./Banner.module.css";

const Banner = () => {
  const handleScrollToServices = () => {
    const section = document.getElementById("services-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className={styles.imgbox}>
      <div className={`${styles.center} overflow-hidden`}>
        <h1 data-aos="fade-down" className={styles.text}>
          <span className={styles.accent}>Mitra</span> Terpercaya untuk
          <br />
          <span className={styles.highlight}>Kebutuhan Bangunan Anda</span>
        </h1>
        <button
          data-aos="fade-up"
          className={`btn custom_btn ${styles.btn}`}
          onClick={handleScrollToServices}
        >
          Produk Kami
        </button>
      </div>
      <div className={styles.warningStripe}></div>
    </div>
  );
};

export default Banner;
